var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--double-bounce",style:(_vm.styles)},[_c('div',{staticClass:"double-bounce1",style:(_vm.bounceStyle)}),_c('div',{staticClass:"double-bounce2",style:(_vm.bounceStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }